<div id="gcc-footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-2 mb-4 gcc-links1">
        <simple-html
          *ngIf="
            this.MISC.fotterProps == null ||
            this.MISC.fotterProps.socialMedia == null
          "
          [whiteSpace]="false"
          [html]="midiasSociais"
        ></simple-html>
      </div>
      <div class="col-lg-2 mb-4 gcc-links2">
        <h3>{{ institucionalTitle1 }}</h3>
        <div *ngFor="let l of values | filterByKey : 'groupId' : 1">
          <a [routerLink]="['info', l.pageId]">{{ l.label }}</a>
        </div>
      </div>
      <div class="col-lg-3 mb-4 gcc-links2">
        <h3>{{ institucionalTitle2 }}</h3>
        <div *ngFor="let l of values | filterByKey : 'groupId' : 2">
          <a [routerLink]="['info', l.pageId]">{{ l.label }}</a>
        </div>
      </div>
      <div class="col-lg-3 mb-4">
        <simple-html [whiteSpace]="false" [html]="ondeEstamos"></simple-html>
      </div>
      <div
        *ngIf="
          this.MISC.fotterProps != null &&
          this.MISC.fotterProps.marketingInforma != null &&
          this.MISC.fotterProps.marketingInforma.enable
        "
        class="col-lg-2 mb-4 gcc-links2"
      >
        <h3>Marketing</h3>
        <div>
          <a routerLink="material-marketing">{{
            this.MISC.fotterProps.marketingInforma.name
          }}</a>
        </div>
      </div>
    </div>
    <!-- <div class="col-lg-5 gcc-links1">
        </div>
        <div class="col-lg-2 gcc-links1"> -->
    <simple-html
      *ngIf="
        this.MISC.fotterProps != null &&
        this.MISC.fotterProps.socialMedia != null &&
        this.MISC.fotterProps.socialMedia.position == 'wide'
      "
      [whiteSpace]="false"
      [html]="midiasSociais"
    ></simple-html>
    <!-- </div>
        <div class="col-lg-5 gcc-links1">
        </div> -->
  </div>
</div>
<div *ngIf="SITE.mostraCopyright" class="row justify-content-center">
  <div
    class="text-center p-4 col-md-2"
    style="color: #888; font-size: 0.7rem; margin-top: 18px"
  >
    <a
      href="http://www.agilb2b.com.br/"
      target="blank"
      style="margin-bottom: 5px"
    >
      <img
        src="assets/logo-agilb2b.png"
        title="PraticoCard"
        class="pb-1"
        style="width: 90px"
      />
    </a>
    <br />
    Ágil B2B<br />
    Solução definitiva para B2B.<br />
    ÁgilB2B © 2020 - Todos os direitos reservados.
  </div>
  <div class="text-center p-4 col-md-2" style="color: #888; font-size: 0.7rem">
    <a href="http://praticocard.com.br/" target="blank">
      <img
        src="assets/logo-parceiro.png"
        title="PraticoCard"
        class="pb-1"
        style="width: 75px"
      />
    </a>
    <br />
    Prático Card<br />
    Seu conciliador de cartões prático.<br />
    Prático Card © 2020 - Todos os direitos reservados.
  </div>
</div>
